export const environment = {
    SERVER_URL: process.env.REACT_APP_SERVER_URL,
    BASE_URL: window.location.protocol + '//' + window.location.hostname + ':' + window.location.port,
};
// app.metasnap.io